import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import type { I18nDefinition } from "@mittwald/flow-components/dist/hooks/useTranslation";
import type { FC } from "react";
import React from "react";

interface StepHeaderItemProps {
  headline: I18nDefinition;
  headlineIcon?: IconDefinition;
  description?: I18nDefinition;
  children?: React.ReactNode;
}

export const StepHeaderItem: FC<StepHeaderItemProps> = (props) => {
  const { headline, headlineIcon, description, children } = props;

  return (
    <Section.Item headline={headline} headlineIcon={headlineIcon}>
      {description && <Text i18n={description} />}
      {children}
    </Section.Item>
  );
};
